import { useEffect, useState } from 'react'

const STORAGE_KEY = 'favoriteItems'

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([])

  // Load favorites from localStorage on component mount
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try {
        setFavorites(JSON.parse(stored))
      } catch (error) {
        console.error('Error parsing favorites:', error)
      }
    }
  }, [])

  // Add a URL to favorites
  const addFavorite = (url: string) => {
    setFavorites((prev) => {
      if (prev.includes(url)) return prev
      const updated = [...prev, url]
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
      return updated
    })
  }

  // Remove a URL from favorites
  const removeFavorite = (url: string) => {
    setFavorites((prev) => {
      const updated = prev.filter((item) => item !== url)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
      return updated
    })
  }

  // Toggle favorite status
  const toggleFavorite = (url: string) => {
    if (favorites.includes(url)) {
      removeFavorite(url)
    } else {
      addFavorite(url)
    }
  }

  // Check if a URL is favorited
  const isFavorite = (url: string) => {
    return favorites.includes(url)
  }

  return {
    favorites,
    addFavorite,
    removeFavorite,
    toggleFavorite,
    isFavorite,
  }
}

